<script>
  export let spacing = "m";
</script>

<vstack {spacing}>
  <slot />
</vstack>
